export default __webpack_public_path__ + "static/media/philosophy.17f1fa1f.jpg";